export function imageUrl (url) {
  return `https://s3.eu-central-1.amazonaws.com/www.bendpanic.com/projects/${url}`;
}

// return uuid of form xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
export function uuid () {
  let uuid = '';
  let ii;
  for (ii = 0; ii < 32; ii += 1) {
    switch (ii) {
      case 8:
      case 20:
        uuid += '-';
        uuid += (Math.random() * 16 | 0).toString(16);
        break;
      case 12:
        uuid += '-';
        uuid += '4';
        break;
      case 16:
        uuid += '-';
        uuid += (Math.random() * 4 | 8).toString(16);
        break;
      default:
        uuid += (Math.random() * 16 | 0).toString(16);
    }
  }
  return uuid;
};



// WEBPACK FOOTER //
// ./src/utils/index.js